import React from 'react';
import ApplyForms from '../components/Apply/ApplyForms';

export default function Apply() {
  return (
    <div>
      <ApplyForms />
    </div>
  )
}